import React, { memo } from 'react';
import { useTheme } from 'emotion-theming';

var handleBackToTop = function handleBackToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

export var BackToTopMobile = /*#__PURE__*/memo(function () {
  var _useTheme = useTheme(),
      white = _useTheme.colors.white;

  return /*#__PURE__*/React.createElement("svg", {
    onClick: handleBackToTop,
    xmlns: "http://www.w3.org/2000/svg",
    width: "95",
    height: "25",
    viewBox: "0 0 200 60"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.871,0A25.171,25.171,0,1,0,93.041,25.171,25.162,25.162,0,0,0,67.871,0Zm15.66,33.466a2.612,2.612,0,0,1-3.718.072l-11.727-11.3L55.929,33.68a2.482,2.482,0,0,1-1.788.715,2.554,2.554,0,0,1-1.931-.858,2.614,2.614,0,0,1,.143-3.718L66.369,16.59a2.658,2.658,0,0,1,3.647,0L83.6,29.676A2.843,2.843,0,0,1,83.531,33.466Z",
    transform: "translate(-12.166)",
    fill: white
  }), /*#__PURE__*/React.createElement("text", {
    fill: white,
    fontSize: "20",
    fontWeight: "500"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "95",
    y: "30"
  }, "Back to Top"))));
});